import type { TFunction } from 'i18next'

import type { KycFieldIssue } from './kycFormState'

/**
 * What the validation error under the fields says.
 *
 * A refused field is drawn in the design's yellow and worded nowhere else, so
 * the page's own refusals have to reach the message — a colour arriving with
 * no reason leaves the user re-reading a page that looks correct.
 *
 * The round's own error outranks them: the server saw the whole form.
 */
export function formValidationError(
  errorMessage: string | undefined,
  issues: readonly KycFieldIssue[],
  t: TFunction,
): string | undefined {
  if (errorMessage !== undefined) {
    return errorMessage
  }
  const issue = issues[0]
  return issue === undefined ? undefined : issueMessage(issue, t)
}

/**
 * One refusal, worded for a message that stands away from the fields.
 *
 * `REQUIRED` and `PATTERN` say "the highlighted fields" rather than naming
 * one: several can be refused at once, and the yellow already points at them.
 */
function issueMessage(issue: KycFieldIssue, t: TFunction): string {
  switch (issue) {
    case 'REQUIRED':
      return t('fiat.kycNoticeRequired')
    case 'COUNTRY_CODE':
      return t('fiat.kycNoticeCountryCode')
    case 'DATE_FORMAT':
      return t('fiat.kycNoticeDateFormat')
    case 'DATE_FUTURE':
      return t('fiat.kycNoticeDatePast')
    case 'DATE_UNDERAGE':
      return t('fiat.kycNoticeUnderage')
    case 'PATTERN':
      return t('fiat.kycNoticeInvalid')
  }
}
